<template>
  <a-input-search
    v-bind="$attrs.item"
    v-model="modelList[name]"
    @change="(e)=>findEvent({e})"
    @search="(e)=>findEvent({e,eventName:'search'})"
    @pressEnter='(e)=>findEvent({e})'
  />

</template>

<script>
import formMixin from '@/minxin/form.mixin.js'
import Search from "ant-design-vue/lib/input/Search";
export default {
  mixins: [formMixin],
  components: { [Search.name]: Search },
  props: {
    name: {},
    modelList: {},
    funcList: {}
  },
}
</script>